module.exports = __webpack_public_path__ + "static/StudioX2-f6a6b270afeccab2f773f79da79d457b.png";